import React from 'react';

export default class Page10 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToWinAndManageResources');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                                <section>
                                    <div className="">
                                        <div className="ilead-rgt task">
                                            <div className="innerpadding">
                                                <div className="ilead-contentarea">


                                                    <div className="circle_title-first"><img
                                                        src={require('@images/Browndot.png')}
                                                        alt=""/>Further Information</div>
                                                    <div className="uiheading"><p>If you found this tool useful then you
                                                        are likely to find the following tools both insightful and
                                                        relevant:</p></div>
                                                    <div className="keyquestionpad">
                                                        <ul className="greenbullet-list sept">
                                                            <li><div
                                                                onClick={this._savePageStatus('HowToInfluenceOthers')}
                                                                className="link_color task button-link-redirect">How to influence others</div>
                                                            </li>
                                                            <li><div
                                                                onClick={this._savePageStatus('HowToManageYourImpact')}
                                                                className="link_color task button-link-redirect">How to manage your
                                                                impact</div></li>
                                                            <li><div
                                                                onClick={this._savePageStatus('HowToCreateTeamIdentity')}
                                                                className="link_color task button-link-redirect">How to create team
                                                                identity</div></li>
                                                            <li><div
                                                                onClick={this._savePageStatus('HowToBuildAndMaintainTrust')}
                                                                className="link_color task button-link-redirect">How to build and maintain
                                                                trust</div></li>
                                                            <li><div
                                                                onClick={this._savePageStatus('HowToGainBuyInAndCommitment')}
                                                                className="link_color task button-link-redirect">How to gain buy-in and
                                                                commitment</div></li>
                                                            <li><div
                                                                onClick={this._savePageStatus('HowToDirectPeople')}
                                                                className="link_color task button-link-redirect">How to direct people</div>
                                                            </li>
                                                            <li><div
                                                                onClick={this._savePageStatus('HowToDelegate')}
                                                                className="link_color task button-link-redirect">How to delegate</div></li>
                                                            <li><div
                                                                onClick={this._savePageStatus('HowToEngageOthersToDeliver')}
                                                                className="link_color task button-link-redirect">How to engage others to
                                                                deliver.</div></li>
                                                        </ul>
                                                    </div>
                                                    <div className="circle_title "><img
                                                        src={require('@images/Browndot.png')}
                                                        alt=""/>REFERENCES</div>

                                                    <ol className="testclass">
                                                        <li><p className="further_info_content">Marks, M., &amp; Harold,
                                                            C. (2011). Who asks and who receives in salary
                                                            negotiation. <span className="subtiltereg"> Journal of Organizational
Behavior,</span> 32(3), 371-394.</p></li>
                                                        <li><p className="further_info_content">Pruit (1981) in Arnold,
                                                            J., Cooper, C &amp; Roberston, I. (1998).<span
                                                                className="subtiltereg">  Work Psychology.</span> Prentice
                                                            Hall.</p></li>
                                                        <li><p className="further_info_content">Jehn, K., Northcraft,
                                                            G. &amp; Neale, M. (1999). Why Differences Make a
                                                            Difference: A Field Study of Diversity,
                                                            Conflict and Performance in Workgroups,<span
                                                                className="subtiltereg">  Administrative Science Quarterly,</span> 44,
                                                            741–763.</p></li>
                                                        <li><p className="further_info_content"><a
                                                            href="http://www.jiscinfonet.ac.uk/InfoKits/project-management/pm-planning-1.1"
                                                            className="link_color task">http://www.jiscinfonet.ac.uk/InfoKits/project-management/pm-planning-1.1</a>
                                                        </p></li>
                                                        <li><p className="further_info_content">Invented in 1917 by
                                                            Henry Gantt as a project management tool.</p></li>
                                                        <li><p className="further_info_content">Adapted from Rutigliano,
                                                            T. &amp; Smith, B. (2003).<span className="subtiltereg"> Discover your Sales Strengths.</span> Random
                                                            House
                                                            Business Books.</p></li>
                                                        <li><p className="further_info_content"><a
                                                            href="http://www.belbin.co.uk/belbin-team-roles.htm"
                                                            className="link_color task">http://www.belbin.co.uk/belbin-team-roles.htm</a>
                                                        </p></li>
                                                    </ol>
                                                    <div className="left-btn">
                                                        <div onClick={this.props.handleChangePage('Page9')}
                                                             className="button-next-previous-done task">&lt;&lt; Previous
                                                        </div>
                                                    </div>
                                                    <div className="right-btn">
                                                        <div
                                                            onClick={this._savePageStatus('Task')}
                                                            className="button-next-previous-done task">Done
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}